import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';

import Home from '@/core/views/Home.vue';
import Invitation from '@/core/views/Invitation.vue';
import { AuthServiceContract, SignInType } from '@/core/contracts/authServiceContract';

/**
 * Aplication routes.
 */
const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { auth: true },
    },
    {
        path: '/contexts/:context',
        name: 'contexts',
        component: Home,
        meta: { auth: true },
    },
    {
        path: '/invitations/:invitation',
        name: 'invitations',
        component: Invitation,
        meta: { auth: true },
    }
];

Vue.use(Router);

/**
 * Build final router for application.
 * @export
 * @param {AuthService} auth
 * @returns {Router}
 */
export function buildRouter(auth: AuthServiceContract): Router {

    // Router configuration:
    const router = new Router({
        mode: 'history',
        base: process.env.BASE_URL,
        routes,
    });

    // Guard runs authentication check for before each
    // route with 'auth':true in meta.
    router.beforeEach(auth.createNavigationGuard());

    // Callbacks for open id authentication.
    router.addRoutes([
        {
            path: '/auth-callback',
            name: 'auth-callback',
            component: auth.createSignInRouteComponent(router, SignInType.Default),
        },
        {
            path: '/silent-callback',
            name: 'silent-callback',
            component: auth.createSignInRouteComponent(router, SignInType.Silent),
        },
    ]);

    return router;
}
